import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import QRCode from 'react-qr-code';
import Axios from 'axios';
import {
  NEW_USER_REGISTRATION,
  CONFIG_PASSWORD_POLICY,
  NEW_USER_REGISTRATION_OTP_VERIFY,
} from '../../../config/rest_endpoints';
import { AUTH_ROUTES } from '../../../routers/RouteConstants';
import Logo from '../../../components/common/Logo';
import '../style.css';

const QRCodeAndPasswordSet = () => {
  const history = useHistory();
  const location = useLocation();

  const { data, token } = location.state;
  const { key } = data.config;

  const [matchPasswordError, setMatchPasswordError] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [step, setStep] = useState(0);
  const [isSpin, setIsSpin] = useState(false);
  const [state, setState] = useState({
    pass: '',
    confimPass: '',
  });
  const [otp, setOtp] = useState({
    mfa_id: '',
    otp: '',
    skip_otp_verification: sessionStorage.getItem('otp-status') || false,
  });
  const [error, setError] = useState(0);
  const [otpError, setOtpError] = useState({
    status: '',
    message: '',
  });

  useEffect(() => {
    if (otp.skip_otp_verification == 'true') {
      setOtpError({
        status: 'success',
        message: 'OTP Verified Please Proceed Next',
      });
    }
  }, [otp.skip_otp_verification]);

  const [otpLoading, setOtpLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [passwordConfig, setpasswordConfig] = useState({
    require_uppercase: false,
    require_lowercase: false,
    require_numbers: false,
    require_specials: false,
    min_length: 0,
  });

  const [validations, setValidations] = useState({
    length: false,
    uppercase: false,
    lowercase: false,
    number: false,
    special: false,
  });

  const validatePasswordWithConfig = (password, config) => {
    return {
      length: password.length >= config.min_length,
      uppercase: !config.require_uppercase || /[A-Z]/.test(password),
      lowercase: !config.require_lowercase || /[a-z]/.test(password),
      number: !config.require_numbers || /[0-9]/.test(password),
      special: !config.require_specials || /[!@#$%^&*(),.?":{}|<>]/.test(password),
    };
  };

  const validatePassword = password => {
    const newValidations = validatePasswordWithConfig(password, passwordConfig);
    setValidations(newValidations);
    return Object.values(newValidations).every(v => v);
  };

  const isPasswordValid = validations => {
    return Object.values(validations).every(v => v);
  };

  const getPasswordConfig = async () => {
    await Axios.get(CONFIG_PASSWORD_POLICY)
      .then(res => {
        setpasswordConfig(res && res.data.response.data);
      })
      .catch(err => {
        console.log('err', err);
      });
  };

  useEffect(() => {
    getPasswordConfig();
  }, [state.pass]);

  const handleText = e => {
    const { name, value } = e.target;
    setState(prevState => ({
      ...prevState,
      [name]: value,
    }));

    if (name === 'pass') {
      validatePassword(value);
      if (state.confimPass) {
        setMatchPasswordError(value !== state.confimPass);
      }
    }

    if (name === 'confimPass') {
      setMatchPasswordError(state.pass !== value);
    }
  };

  const handleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const clearFields = () => {
    setState({ pass: '' });
    setOtp({
      mfa_id: '',
      otp: '',
      skip_otp_verification: false,
    });

    localStorage.removeItem('otp-status');
  };

  const clearRequestTimeOut = () => {
    setTimeout(() => {
      setError(false);
    }, 3000);
  };

  const renderError = () => {
    return error === 1 ? (
      <div className="alert alert-success alert-styled-right alert-dismissible">
        <button type="button" className="close" data-dismiss="alert">
          <span>×</span>
        </button>
        <span className="font-weight-semibold">{message}</span>
      </div>
    ) : error === -1 ? (
      <div className="alert alert-danger alert-styled-right alert-dismissible">
        <button type="button" className="close" data-dismiss="alert">
          <span>×</span>
        </button>
        <span className="font-weight-semibold">{message}</span>
      </div>
    ) : (
      ''
    );
  };

  const renderPasswordRequirements = () => {
    if (!state.pass) return null;

    return (
      <div
        className="password-requirements font-weight-bold"
        style={{
          fontSize: '0.8rem',
          color: '#666',
        }}
      >
        <div style={{ marginBottom: '0.5rem' }}>Password must contain:</div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '0.25rem' }}>
          <div style={{ color: validations.length ? '#4caf50' : 'rgba(255, 0, 0, 0.637)' }}>
            {validations.length ? '✓' : 'x'} At least {passwordConfig.min_length} characters
          </div>
          <div style={{ color: validations.uppercase ? '#4caf50' : 'rgba(255, 0, 0, 0.637)' }}>
            {validations.uppercase ? '✓' : 'x'} One uppercase letter
          </div>
          <div style={{ color: validations.lowercase ? '#4caf50' : 'rgba(255, 0, 0, 0.637)' }}>
            {validations.lowercase ? '✓' : 'x'} One lowercase letter
          </div>
          <div style={{ color: validations.number ? '#4caf50' : 'rgba(255, 0, 0, 0.637)' }}>
            {validations.number ? '✓' : 'x'} One number
          </div>
          <div style={{ color: validations.special ? '#4caf50' : 'rgba(255, 0, 0, 0.637)' }}>
            {validations.special ? '✓' : 'x'} One special character (!@#$%^&*(),.?":{}|<></>)
          </div>
        </div>
      </div>
    );
  };

  const submitPassword = async () => {
    try {
      const configResponse = await Axios.get(CONFIG_PASSWORD_POLICY);
      const freshConfig = configResponse?.data?.response?.data;
      if (!freshConfig) {
        setError(-1);
        setMessage('Unable to verify password requirements');
        return;
      }
      const finalValidation = validatePasswordWithConfig(state.pass, freshConfig);
      if (!isPasswordValid(finalValidation)) {
        setError(-1);
        setMessage(
          'Password does not meet current requirements. Please check the requirements and try again.'
        );
        setpasswordConfig(freshConfig);
        setValidations(finalValidation);
        return;
      }
      if (state.confimPass !== state.pass) {
        setMatchPasswordError(true);
        return;
      }
      const payload = {
        pass: state.pass,
        mfa_id: data.id,
        skip_otp_verification: true,
      };
      const headers = { Authorization: 'Bearer ' + token };

      setIsSpin(true);

      const res = await Axios.post(NEW_USER_REGISTRATION, payload, { headers });

      if (res.status === 200) {
        const resp = res.data.response;
        setError(1);
        setMessage(resp.msg);
        clearFields();
        setIsSpin(false);
        const token = resp.data.token;
        localStorage.setItem('verifyToken', JSON.stringify(token));
        sessionStorage.removeItem('otp-status');
        setTimeout(() => history.push(`${AUTH_ROUTES.login}`), 1000);
      }
    } catch (err) {
      setError(-1);
      setMessage(err.response?.data?.response?.msg || 'Failed to register');
      setIsSpin(false);
    } finally {
      clearRequestTimeOut();
    }
  };

  const renderGuide = () => (
    <div
      className="d-flex flex-column justify-content-between"
      style={{ height: '100%', gap: '25px' }}
    >
      <div className="card-header pb-0">
        <h3 className="text-left d-flex align-items-start m-0" style={{ gap: '10px' }}>
          <span
            style={{ fontWeight: '600', fontSize: '60px', lineHeight: '55px', color: '#616161' }}
          >
            2
          </span>{' '}
          Add this code to your Authenticator App
        </h3>
      </div>
      <div className="text-center" style={{ margin: 'auto' }}>
        <QRCode value={key} size={200} />

        <h5 style={{ lineHeight: '25px', marginTop: '10px', marginBottom: '0', color: '#616161' }}>
          <span style={{ fontWeight: '600' }}>Manual Setup Key</span> <br /> {data?.secret}
        </h5>
      </div>

      <article className="d-flex justify-content-between mx-4">
        <button
          className="btn btn-warning d-flex align-items-center"
          style={{ gap: '5px' }}
          onClick={() => history.goBack()}
        >
          <i className="icon-arrow-left8 ml-1 icon-1x"></i> Back
        </button>
        <button className="btn btn-success" onClick={() => setStep(1)}>
          Next <i className="icon-arrow-right8 ml-1 icon-1x"></i>
        </button>
      </article>
    </div>
  );

  const handleOtpVerify = async () => {
    setOtpLoading(true);

    try {
      const payload = {
        otp: otp.otp,
        mfa_id: data.id,
      };

      const headers = {
        Authorization: `Bearer ${token}`,
      };

      const res = await Axios.post(NEW_USER_REGISTRATION_OTP_VERIFY, payload, { headers });

      if (res.status === 200) {
        sessionStorage.setItem('otp-status', 'true');

        setOtp(prev => ({
          ...prev,
          skip_otp_verification: true,
        }));
        setOtpError({
          status: 'success',
          message: res?.data?.response?.msg + ' ' + 'Please Click Next',
        });
      }
    } catch (error) {
      console.error('OTP Verification Error:', error?.response?.data?.response?.error);
      setOtpError({
        status: 'error',
        message: error?.response?.data?.response?.error || 'Something went wrong',
      });
    } finally {
      setOtpLoading(false);
    }
  };

  const renderOtpForm = () => (
    <div style={{ margin: 'auto' }}>
      <div className="card-header">
        <h2
          className="text-left d-flex align-items-center"
          style={{ gap: '10px', color: '#616161', lineHeight: '55px' }}
        >
          <span style={{ fontWeight: '600', fontSize: '50px' }}>3</span> Confirm Your Authenticator
          Code
        </h2>
      </div>
      <div
        className="card-body d-flex flex-column justify-content-between"
        style={{ height: '300px' }}
      >
        <article>
          <div className="form-group form-group-feedback form-group-feedback-left">
            <input
              type="text"
              className="form-control"
              name="otp"
              value={otp.otp}
              onChange={e => setOtp({ ...otp, otp: e.target.value })}
              placeholder="Google Authenticator Code"
              disabled={otp.skip_otp_verification}
            />
            <div className="form-control-feedback">
              <img src={data.logo_big} alt="Google Auth App" style={{ width: '20px' }} />
            </div>
          </div>
          {otpError?.status && (
            <span
              className="d-flex align-items-center"
              style={{ color: otpError?.status == 'error' ? 'red' : '#17a6a8', marginTop: '-10px' }}
            >
              * {otpError.message}
            </span>
          )}
          <button
            className={`btn ${otp.otp.trim().length == 0 ? 'btn-secondary' : 'btn-success'} mt-1`}
            style={{ width: '100%' }}
            disabled={otp.otp.trim().length == 0 || otpLoading || otp.skip_otp_verification}
            onClick={handleOtpVerify}
          >
            {otpLoading ? 'Confirming...' : 'Confirm'}
          </button>
        </article>
        <div className="d-flex justify-content-between">
          <button
            className="btn btn-warning d-flex align-items-center"
            style={{ gap: '12px', width: '100px' }}
            onClick={() => setStep(0)}
          >
            <i className="icon-arrow-left8 ml-1 icon-1x"></i>
            Back
          </button>
          <button
            className={`btn ${!otp.skip_otp_verification ? 'btn-secondary' : 'btn-success'} d-flex align-items-center`}
            onClick={() => setStep(2)}
            style={{ gap: '12px', width: '100px' }}
            disabled={!otp.skip_otp_verification}
          >
            Next
            <i className="icon-arrow-right8 ml-1 icon-1x"></i>
          </button>
        </div>
      </div>
    </div>
  );

  const renderPasswordForm = () => (
    <div
      style={{ margin: 'auto', height: '430px' }}
      className="d-flex flex-column justify-content-between"
    >
      <div className="card-header">
        <h2
          className="text-left d-flex align-items-center"
          style={{ gap: '10px', color: '#616161' }}
        >
          <span style={{ fontWeight: '600', fontSize: '50px', lineHeight: '55px' }}>4</span> Set
          Your New Password and login
        </h2>
      </div>
      <div className="card-body d-flex flex-column justify-content-between">
        {renderError()}

        <article>
          <div className="form-group form-group-feedback form-group-feedback-left mb-2">
            <input
              type={showPassword ? 'text' : 'password'}
              className="form-control"
              name="pass"
              value={state.pass}
              onChange={handleText}
              placeholder="New Password"
            />
            <div className="form-control-feedback" onClick={handleShowPassword}>
              <img
                src={
                  showPassword
                    ? '/assets/svg-icons/bi-eye.svg'
                    : '/assets/svg-icons/bi-eye-slash.svg'
                }
                alt="eye"
                className="eye-icon"
              />
            </div>
          </div>

          <div className="form-group form-group-feedback form-group-feedback-left">
            <input
              type={showPassword ? 'text' : 'password'}
              className="form-control"
              name="confimPass"
              value={state.confimPass}
              onChange={handleText}
              placeholder="Confirm New Password"
            />
            <div className="form-control-feedback" onClick={handleShowPassword}>
              <img
                src={
                  showPassword
                    ? '/assets/svg-icons/bi-eye.svg'
                    : '/assets/svg-icons/bi-eye-slash.svg'
                }
                alt="eye"
                className="eye-icon"
              />
            </div>
            {renderPasswordRequirements()}
            {matchPasswordError && (
              <span className="password-match-error font-weight-bold d-block">
                x Both Password must match!
              </span>
            )}
          </div>
        </article>
        <div className="d-flex justify-content-between" style={{ gap: '50px' }}>
          <button
            className="btn btn-warning d-flex align-items-center"
            style={{ gap: '12px' }}
            onClick={() => setStep(1)}
          >
            <i className="icon-arrow-left8 ml-1 icon-1x"></i>
            Back
          </button>
          <button type="submit" className="btn btn-success " onClick={submitPassword}>
            Login{' '}
            <i className={isSpin ? 'icon-spinner2 spinner ml-2' : 'icon-arrow-right8 ml-2'}></i>
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <section className="login-form-container">
      <article className="login-page">
        <pciture className="site-logo">
          <Logo width={'450px'} height={'450px'} />
        </pciture>
        {/* {state.pass ? <Logo width={530} height={530} /> : <Logo width={420} height={420} />} */}
        <div className="login-form">
          {step === 0 && renderGuide()}
          {step === 1 && renderOtpForm()}
          {step === 2 && renderPasswordForm()}
        </div>
      </article>
    </section>
  );
};

export default QRCodeAndPasswordSet;
